// extracted by mini-css-extract-plugin
export var oWhoWeAre = "whoWeAre-module--o-who-we-are--1BNmF";
export var lContent__inner = "whoWeAre-module--l-content__inner--2Jy0W";
export var oWhoWeAre__balloon = "whoWeAre-module--o-who-we-are__balloon--2gEEw";
export var designEngineer = "whoWeAre-module--design-engineer--NiLfB";
export var specialist = "whoWeAre-module--specialist--2z5NV";
export var history = "whoWeAre-module--history--hvdBf";
export var oWhoWeAre__decorationSpecialist = "whoWeAre-module--o-who-we-are__decoration--specialist--RV-CQ";
export var oWhoWeAre__decorationUiux = "whoWeAre-module--o-who-we-are__decoration--uiux--34aMq";
export var visible = "whoWeAre-module--visible--BLpe9";
export var subcopyBefore = "whoWeAre-module--subcopy-before--38kyg";
export var subcopyAfter = "whoWeAre-module--subcopy-after--2_jDe";
export var standby = "whoWeAre-module--standby--2FHHQ";